import { useState } from "react";
import {
  buildAuditJourneyText,
  type AuditSession,
} from "../../utils/bookingFormAuditSession";
import { copyTextToClipboard } from "../../utils/bookingResumeLink";

type Props = {
  session: AuditSession;
  vehicleNames?: Record<string, string>;
  className?: string;
};

export default function CopyAuditJourneyButton({
  session,
  vehicleNames,
  className,
}: Props) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const text = buildAuditJourneyText(session, { vehicleNames });
    const ok = await copyTextToClipboard(text);
    if (!ok) return;
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      type="button"
      onClick={() => void handleCopy()}
      className={
        className ??
        "rounded-lg border border-brand-300 bg-white px-3 py-1.5 text-xs font-medium text-brand-700 hover:bg-brand-50 dark:border-brand-500/40 dark:bg-gray-900 dark:text-brand-300"
      }
      aria-label="Copy journey for analysis"
      title="Copy full journey text for AI / analysis"
    >
      {copied ? "Copied journey" : "Copy journey"}
    </button>
  );
}
